export default class PricePackageCartItem {
    constructor(pricePackage, amount) {
        this.pricePackage = pricePackage;
        this.amount = amount;
    }

    incrementAmount(add) {
        this.amount += add;
    }
}
